<template>
    <div v-if="app">
        <EditorV5 :app="app" :settings="settings" v-if="app.app_version >= 4" />
    </div>
</template>


<script>
import EditorV5 from './EditorV5'

export default {
    name: 'Editor',
    components: {
        EditorV5,
    },
    data: function() {
        return {
            app: null,
            data: null,
            saving: false,    
        }
    },
    computed: {
        settings() {
            return this.app.settings.find(s => {
                return s.version == this.$route.query.v
            })
        },
    },

    async mounted() {
        try {
            let { data } = await this.$http.get(`/v3/system/gateway/app-service/public-app/${this.$route.params.id}/settings`)

            if (data.owner) {
                this.$mainDialog.msgBoxOk("This public-app is managed by external source.")
                return
            }

            this.app = _.cloneDeep(data)
       }  catch(err) {
            this.$debugLog(err)
            this.$mainDialog.msgBoxOk("Failed to fetch component settings.")
        }
    }
}
</script>